export type TooltipColor = 'Gray' | 'Red' | 'Mango';

export const TOOLTIP_COLOR_CLASSES: Record<TooltipColor, string> = {
  Gray: 'tw-bg-metal-90 tw-text-light dark:tw-bg-metal-50 dark:tw-text-dark',
  Red: 'tw-surface-red',
  Mango: 'tw-surface-mango',
};
